import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks/useAuth';
import { SectionMarker } from '../../components/SectionMarker';
import { CoordinateMarker } from '../../components/CoordinateMarker';
import { FooterState } from '../../components/FooterState';
import { StickyCta } from '../../components/StickyCta';
export function Verify() {
    const { t } = useTranslation(['auth', 'common']);
    const navigate = useNavigate();
    const [search] = useSearchParams();
    const { isAuthenticated, isLoading, refresh } = useAuth();
    const [errored, setErrored] = useState(null);
    useEffect(() => {
        const err = search.get('error');
        if (err) {
            setErrored(err);
            return;
        }
        void refresh();
    }, [search, refresh]);
    useEffect(() => {
        if (!errored && !isLoading && isAuthenticated) {
            navigate('/library', { replace: true });
        }
    }, [errored, isLoading, isAuthenticated, navigate]);
    const phase = errored
        ? 'error'
        : !isLoading && isAuthenticated
            ? 'success'
            : 'loading';
    const stateLabel = phase === 'error'
        ? t('auth:verify.error.footer_state', { defaultValue: 'lien expire' })
        : phase === 'success'
            ? t('auth:verify.success.footer_state', { defaultValue: 'session active' })
            : t('auth:verify.loading.footer_state', { defaultValue: 'verification' });
    return (_jsxs("section", { className: "flex min-h-dvh flex-1 flex-col items-center justify-between gap-8 px-8 pb-12 pt-20", children: [_jsxs("div", { className: "flex flex-col items-center gap-3", children: [_jsx(SectionMarker, { num: "O\u2014V", label: t('auth:verify.eyebrow', { defaultValue: 'lien magique' }) }), _jsx(CoordinateMarker, { prefix: "S", num: "V", suffix: "001" })] }), _jsxs("div", { className: "flex flex-col items-center gap-7", children: [_jsx("div", { "aria-hidden": true, className: `
            relative flex h-24 w-24 items-center justify-center
            border-[1.5px] bg-cyan-surface
            before:pointer-events-none before:absolute before:-inset-[6px]
            before:border before:border-cyan-border before:content-['']
            ${phase === 'error' ? 'border-cyan-media' : 'border-cyan-core'}
          `, children: _jsx("span", { className: `
              font-display text-[72px] font-medium leading-none tracking-cy-display
              ${phase === 'error' ? 'text-cyan-media' : 'text-cyan-core'}
            `, children: "L" }) }), _jsxs("div", { className: "flex flex-col items-center gap-3 text-center", children: [_jsx("h1", { className: "font-display text-[24px] font-medium leading-[1.1] tracking-cy-display text-cyan-text", children: phase === 'error'
                                    ? t('auth:verify.error.title', { defaultValue: 'Lien expire' })
                                    : phase === 'success'
                                        ? t('auth:verify.success.title', { defaultValue: 'Connecte.' })
                                        : t('auth:verify.loading.title', { defaultValue: 'Verification en cours' }) }), _jsx("p", { className: "max-w-[300px] text-[13px] font-light leading-5 text-cyan-text-secondary", children: phase === 'error'
                                    ? t('auth:verify.error.body', {
                                        defaultValue: 'Le lien a expire ou a deja ete utilise. Demande un nouveau lien magique.',
                                    })
                                    : phase === 'success'
                                        ? t('auth:verify.success.body', {
                                            defaultValue: 'Redirection en cours.',
                                        })
                                        : t('auth:verify.loading.body', {
                                            defaultValue: 'On valide ton lien.',
                                        }) })] })] }), _jsx("div", { className: "w-full", children: _jsx(FooterState, { state: stateLabel, coord: "S\u2014V \u00B7 001" }) }), phase === 'error' ? (_jsx(StickyCta, { children: _jsx("button", { type: "button", onClick: () => navigate('/onboarding/signup'), className: "\n              inline-flex h-12 w-full items-center justify-center\n              bg-cyan-core text-cyan-surface\n              font-display text-[14px] font-medium tracking-[-0.01em]\n              transition active:scale-[0.985]\n              hover:bg-cyan-network\n            ", children: t('auth:verify.error.cta', { defaultValue: 'Demander un nouveau lien' }) }) })) : null] }));
}
//# sourceMappingURL=Verify.js.map